/**
 * Asynchronously loads the component
 */
import Loadable from 'react-loadable';

import { StyledSpinnerContainer } from './StyledComponents';

export default Loadable({
    loader: () => import('./index'),
    loading: StyledSpinnerContainer,
});
